const apiUrl = 'http://127.0.0.1:8000';
const douzeroDemoUrl = 'https://douzero.org:5000';

export { apiUrl, douzeroDemoUrl };
